// import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// importing components 
import Home from './Components/Home';
import About from './Components/About';
import Menu from './Components/Menu';
import Staff from './Components/Staff';
import Services from './Components/Services';
import Contact from './Components/Contact';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Carousel from './Components/Carousel';
import Vegetarian from './Components/Vegetarian';
import Nonvegetarian from './Components/Nonvegetarian';
import Sweets from './Components/Sweets';
import Beverage from './Components/Beverage';


function App() {
  return (
    <>
      <Router>
        <Navbar></Navbar>
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route exact path="/about" element={<About />}></Route>
          <Route exact path="/menu" element={<Menu />}></Route>
          <Route exact path="/staff" element={<Staff />}></Route>
          <Route exact path="/services" element={<Services />}></Route>
          <Route exact path="/contact" element={<Contact />}></Route>
          <Route exact path="/Vegetarian" element={<Vegetarian />}></Route>
          <Route
            exact
            path="/Nonvegetarian"
            element={<Nonvegetarian />}
          ></Route>
          <Route exact path="/Sweets" element={<Sweets />}></Route>
          <Route exact path="/Beverage" element={<Beverage />}></Route>
        </Routes>
      </Router>
      <Carousel></Carousel>
      <Footer></Footer>
    </>
  );
}

export default App;
